import { Body } from "sunday-component";
import { Col } from "antd";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import Button from "../Common/Button";
import PhoneIcon from "../Common/Icons/PhoneIcon";
import EmailIcon from "../Common/Icons/EmailIcon";
import LineIcon from "../Common/Icons/LineIcon";
import {
  ContactContainer,
  ContactItem,
  ContactLink,
  IconContainer,
  Modal,
  ModalBody,
  Title,
} from "./style/ContactModal.style";

export type ContactModalProp = {
  visible: boolean;
  onCloseModal?: Function;
  contact: any;
};

const ContactModal = ({
  visible = false,
  onCloseModal = () => {},
  contact = {},
}: ContactModalProp) => {
  const { t } = useTranslation("contact");
  const { locale } = useRouter();

  const handleOnCloseModal = () => {
    onCloseModal();
  };

  return (
    <Modal
      title={
        <Title level={6} style={{ textAlign: "center" }}>
          {t("title")}
        </Title>
      }
      closable={false}
      footer={
        <Button fullWidth onClick={handleOnCloseModal}>
          {t("closeButton")}
        </Button>
      }
      visible={visible}
      onCancel={handleOnCloseModal}
      centered
    >
      <ModalBody level={7}>{t("subTitle")}</ModalBody>
      <ContactContainer>
        <ContactItem>
          <Col>
            <IconContainer>
              <PhoneIcon width={32} height={32} />
            </IconContainer>
          </Col>
          <Col style={{ textAlign: "left" }}>
            <Title level={7}>{contact.cs?.title[locale]}</Title>
            <a href={contact.cs?.telLink}>
              <ContactLink level={7}>{contact.cs?.tel}</ContactLink>
            </a>
            <Body level={9}>{t("mobile.subTitle")}</Body>
          </Col>
        </ContactItem>
        <ContactItem>
          <Col>
            <IconContainer>
              <EmailIcon width={32} height={32} />
            </IconContainer>
          </Col>
          <Col style={{ textAlign: "left" }}>
            <Title level={7}>{contact.email?.title[locale]}</Title>
            <a href={contact.email?.emailLink}>
              <ContactLink level={7}>{contact.email?.email}</ContactLink>
            </a>
            <Body level={9}>{t("email.subTitle")}</Body>
          </Col>
        </ContactItem>
        <ContactItem>
          <Col>
            <IconContainer>
              <LineIcon width={32} height={32} />
            </IconContainer>
          </Col>
          <Col style={{ textAlign: "left" }}>
            <Title level={7}>{contact.line?.title[locale]}</Title>
            <a href={contact.line?.lineIdLink}>
              <ContactLink level={7}>{contact.line?.lineId}</ContactLink>
            </a>
            <Body level={9}>{t("line.subTitle")}</Body>
          </Col>
        </ContactItem>
      </ContactContainer>
    </Modal>
  );
};

export default ContactModal;
